import { useState, useEffect, useRef } from 'react';

import CardsOrganizational from '../components/CardsOrganizational'
import Charts from '../components/Charts';
import RiskAnalysisTable from '../components/RiskAnalysisTable';
import DatePicker from "../components/DatePicker";
import { useMicrosoftAuth } from "../context/MicrosoftAuthContext";
import MetricsConsideredModal from '../components/MetricsConsideredModal';
import OrganizationalMetricsModal from '../components/OrganizationalMetricsModal';
import { useOrganizationalMetricsModal } from '../hooks/useOrganizationalMetricsModal';

import { fetchData, fetchDataPost, checkAccessToken } from "../services/apiService";
import { getPopupTableColumnName } from '../utils/commonUtils';

// import { FaCircle, FaHome } from "react-icons/fa"; // Using react-icons for icons


const Dashboard = ({ isOpen, toggle }) => {
    const { userTeamData } = useMicrosoftAuth();
    const controllerRef = useRef(new AbortController());

    const startOfMonth = new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth(), 1));
    const endOfMonth = new Date(Date.UTC(new Date().getFullYear(), new Date().getMonth() + 1, 0));
    const defaultStartDate = startOfMonth;
    const defaultEndDate = endOfMonth;

    const [dateRange, setDateRange] = useState([defaultStartDate, defaultEndDate]);
    const [startDate, endDate] = dateRange;

    const [totalAssistants, setTotalAssistants] = useState(0);
    const [totalBranches, setTotalBranches] = useState(0);
    const [totalManagers, setTotalManagers] = useState(0);
    const [totalPODS, setTotalPODS] = useState(0);
    const [totalTeamMembers, setTotalTeamMembers] = useState(0);

    const [objectives, setObjectives] = useState([]);
    const [objectivesCountLoading, setObjectivesCountLoading] = useState(true);
    const [error, setError] = useState(null);

    const [greenMeticsCount, setGreenMeticsCount] = useState(0);
    const [yellowMeticsCount, setYellowMeticsCount] = useState(0);
    const [redMeticsCount, setRedMeticsCount] = useState(0);
    const [dateRangeData, setDateRangeData] = useState([]);
    const [metricsDateRangeData, setMetricsDateRangeData] = useState([]);
    const [metricBranchDataRangeData, setMetricBranchDataRangeData] = useState([]);
    const [metricManagersDataRangeData, setMetricManagersDataRangeData] = useState([]);
    const [metricAssistantsDataRangeData, setMetricAssistantsDataRangeData] = useState([]);
    const [metricPodsDataRangeData, setMetricPodsDataRangeData] = useState([]);

    const [organizationalEvaluationLoading, setOrganizationalEvaluationLoading] = useState(false);

    // const [objectivesCountLoading, setObjectivesCountLoading] = useState(true);
    // const [error, setError] = useState(null);

    const [metrics, setMetrics] = useState([]);
    const [showMetricsModal, setShowMetricsModal] = useState(false);

    // Organizational Metrics Modal
    const {
        modalState: orgMetricsModalState,
        handleMetricsCardClick: handleOrgMetricsCardClick,
        closeModal: closeOrgMetricsModal
    } = useOrganizationalMetricsModal();

    var organizations = [];
    if(!userTeamData?.user_role_id.includes("10") && userTeamData?.user_role_id.includes("1") && userTeamData?.manager_has_branches){
        organizations = [
            { "organizationsName": "branches", "organizationsLabel": "All Branches" },
            { "organizationsName": "myassistants", "organizationsLabel": "My Assistants" },
        ];
    }else if(!userTeamData?.user_role_id.includes("10") && userTeamData?.user_role_id.includes("5") && userTeamData?.area_director_has_branches){
        organizations = [
            { "organizationsName": "myself", "organizationsLabel": "Myself" },
            { "organizationsName": "branches", "organizationsLabel": "My Branches" },
        ];
    }else if(!userTeamData?.user_role_id.includes("10") && userTeamData?.user_role_id.includes("1")){
        organizations = [
            { "organizationsName": "myself", "organizationsLabel": "Myself" },
            { "organizationsName": "myassistants", "organizationsLabel": "My Assistants" },
        ];
    }else if(!userTeamData?.user_role_id.includes("10") && userTeamData?.user_role_id.includes("5")){
        organizations = [
            { "organizationsName": "myself", "organizationsLabel": "Myself" },
        ];
    }else if(userTeamData?.user_role_id.includes("10")){
        organizations  = [
            { "organizationsName": "branches", "organizationsLabel": "All Branches" },
            { "organizationsName": "managers", "organizationsLabel": "All Managers" },
            { "organizationsName": "assistants", "organizationsLabel": "All Assistants" },
            { "organizationsName": "team_pods", "organizationsLabel": "All Pods/Teams" },
        ];
    }else{
        organizations = [
            { "organizationsName": "myself", "organizationsLabel": "Myself" }
        ];
    }

    const [activeOrganizationTab, setActiveOrganizationTab] = useState(organizations[0].organizationsName);
    const [activeObjectiveTab, setActiveObjectiveTab] = useState(0);
    const [activeObjectiveName, setActiveObjectiveName] = useState('');
    const [frequency, setFrequency] = useState('weekly');

    const [activeMetric, setActiveMetric] = useState({});

    const handleDateRangeChange = (newDateRange) => {
        // Create dates in UTC using Date.UTC()
        const startOfMonth = new Date(Date.UTC(newDateRange.startYear, newDateRange.startMonth - 1, 1));
        const endOfMonth = new Date(Date.UTC(newDateRange.endYear, newDateRange.endMonth, 0));
    
        // The rest of your function remains the same
        newDateRange = [startOfMonth, endOfMonth];
        setDateRange(newDateRange);
        const [startDate, endDate] = newDateRange;
        
        if (startDate && endDate) {
            // Abort existing request
            if (controllerRef.current) {
                controllerRef.current.abort();
            }
            
            // Create new controller
            controllerRef.current = new AbortController();
            getOrganizationalEvaluation(activeOrganizationTab, activeObjectiveTab, startDate, endDate, frequency);
        }
    };
    async function getUserCountsByRoles() {
        try {
            var post_data = {};
            post_data.user_team_id = userTeamData?.id;
            post_data.user_role_id = userTeamData?.user_role_id;
            if(!userTeamData?.user_role_id.includes("10")){
                var user_group = [];
                userTeamData?.user_group?.forEach(group => {
                    user_group.push(group);
                });
                post_data.user_group = user_group;
            }

            const result = await fetchDataPost('getUserCountsByRoles', post_data, controllerRef.current);
            if (result != null) {
                setTotalAssistants(result.totalAssistants);
                setTotalBranches(result.totalBranches);
                setTotalManagers(result.totalManagers);
                setTotalPODS(result.totalPODS);
                setTotalTeamMembers(result.totalTeamMembers);
            }
        } catch (err) {
            console.log(err.message);
        } finally {
            setObjectivesCountLoading(false);
        }
    }
    async function getObjectives() {
        try {
            const result = await fetchData('getObjectives', controllerRef.current);

            const [startDate, endDate] = dateRange;
            if (result != null) {
                setObjectives(result);
                if (result.length > 0) {
                    setActiveObjectiveTab(result[0].id);

                    const activeObjective = result.find(objective => objective.id === result[0].id);
                    setActiveObjectiveName(activeObjective ? activeObjective.name : '');
                    getOrganizationalEvaluation(activeOrganizationTab, result[0].id, startDate, endDate, frequency);
                }
            }
        } catch (err) {
            console.log(err.message);
        } finally {
            setObjectivesCountLoading(false);
        }
    }

    async function getOrganizationalEvaluation(activeOrganizationTab, activeObjectiveTab, startDate, endDate, frequency = 'weekly') {
        setOrganizationalEvaluationLoading(true);
        try {
            var post_data = {};
            if (startDate) {
                // post_data.startDate = `${startDate.getFullYear()}-${(startDate.getMonth() + 1)}-${startDate.getDate()}`;
                post_data.startDate = startDate;
            }
            if (endDate) {
                var endDateWithAdjustedTime = new Date(endDate);
                endDateWithAdjustedTime.setUTCHours(23, 59, 59, 999);
                post_data.endDate = endDateWithAdjustedTime;
            }
            // for (const objective of objectives) {
            //     if (activeObjectiveTab == objective.id) {
            //         post_data.objectiveID = objective.id;
            //     }
            // }
            post_data.objectiveID = activeObjectiveTab;
            post_data.organization = activeOrganizationTab;
            if(activeOrganizationTab=='myself'){
                post_data.id = userTeamData?.id;
            }
            post_data.frequency = frequency;
            post_data.user_team_id = userTeamData?.id;
            post_data.user_role_id = userTeamData?.user_role_id;
            if(!userTeamData?.user_role_id.includes("10")){
                var user_group = [];
                userTeamData?.user_group?.forEach(group => {
                    user_group.push(group);
                });
                post_data.user_group = user_group;
            }
            
            const result = await fetchDataPost('getOrganizationalEvaluation', post_data, controllerRef.current);
            console.log("result",result);
            if (result != null) {
                setMetrics(result.showMetrics);
                if(result.showMetrics.length>0){
                   setActiveMetric(result.showMetrics[0]);
                }
                setGreenMeticsCount(result.summary.greenMeticsCount??0);
                setYellowMeticsCount(result.summary.yellowMeticsCount??0);
                setRedMeticsCount(result.summary.redMeticsCount??0);
                setDateRangeData(result.dateRangeData);
                setMetricsDateRangeData(result.singleMetricsData);
                setMetricBranchDataRangeData(result.singleMetricBranchData);
                setMetricManagersDataRangeData(result.singleMetricManagersData || []);
                setMetricAssistantsDataRangeData(result.singleMetricAssistantData || []);
                setMetricPodsDataRangeData(result.singleMetricPodsData || []);

                console.log(result.dateRangeData);
            }
            setOrganizationalEvaluationLoading(false);
        } catch (err) {
            console.log("err.message", err.message);
            // Don't set loading to false if request was cancelled
            if (err.name === 'AbortError' || err.message === 'canceled') {
                console.log('Request was cancelled');
                // Don't update loading state for cancelled requests
            } else {
                // Keep loading state as true for other errors
                console.log('Request failed with error');
                setOrganizationalEvaluationLoading(true);
            }
        } 
    }

    const handleMetricsCardClick = () => {
        setShowMetricsModal(true);
    };

    const handleOrganizationalMetricsCardClick = (cardType) => {
        handleOrgMetricsCardClick(cardType, {
            date: startDate || new Date(),
            title: activeObjectiveName
        });
    };

    const getMetricDataByTab = () => {
        switch(activeOrganizationTab) {
            case 'branches':
                return metricBranchDataRangeData;
            case 'managers':
                return metricManagersDataRangeData;
            case 'assistants':
                return metricAssistantsDataRangeData;
            case 'team_pods':
                return metricPodsDataRangeData;
            default:
                return metricBranchDataRangeData;
        }
    };
    const loadData = async () => {
        setObjectivesCountLoading(true);
        await checkAccessToken(controllerRef.current);
        getUserCountsByRoles();
        getObjectives();
    }
    useEffect(() => {
        loadData();
    }, []);


    return (
        <div className='bg-white p-30-19'>
            <div className='d-flex align-items-center justify-content-between mb-24'>
                <div>
                    <div className='text-20 fw-700' style={{color: '#072837'}}>Hi, {userTeamData?.name || 'User'}</div>
                    {/* <div className='text-16 fw-400' style={{color: '#686868'}}>Lorem ipsum dolor sit amet consectetur. Nunc sed eleifend egestas nisl orci.</div> */}
                </div>
            </div>
            <div className="org-details-container border border-neutral rounded-20 bg-white p-24 mb-24">
                <div className="text-24 fw-600 text-navy">Organizational Details</div>
                <div className="org-details-cards-container">
                    {(userTeamData?.user_role_id.includes("10") || userTeamData?.manager_has_branches || userTeamData?.area_director_has_branches) && (
                        <div>
                            <CardsOrganizational
                                totalCount={totalBranches.toString().padStart(2, '0')}
                                CardLabel="Total Branches"
                                iconName="branches"
                                PageRoute="/branches"
                            />
                        </div>
                    )}
                    {userTeamData?.user_role_id.includes("10") && (
                        <div>
                            <CardsOrganizational
                                totalCount={totalManagers.toString().padStart(2, '0')}
                                CardLabel="Total Managers"
                                iconName="managers"
                                PageRoute="/manager"
                            />
                        </div>
                    )}
                    {(userTeamData?.user_role_id.includes("10") || userTeamData?.user_role_id.includes("1")) && (
                        <div>
                            <CardsOrganizational
                                totalCount={totalAssistants.toString().padStart(2, '0')}
                                CardLabel="Total Assistants"
                                iconName="assistants"
                                PageRoute="/assistants"
                            />
                        </div>
                    )}
                    {userTeamData?.user_role_id.includes("10") && (
                        <div>
                            <CardsOrganizational
                                totalCount={totalPODS.toString().padStart(2, '0')}
                                CardLabel="Total Pods/Teams"
                                iconName="teams"
                                PageRoute="/teams_pods"
                            />
                        </div>
                    )}
                </div>
            </div>
            <div className='organizational-analytics-container mb-24'>
                <div className='organizational-analytics-title'>Organizational Analytics</div>

                <div className='analytics-controls-container'>
                    <div className='analytics-section'>
                        {/* Organization Tabs */}
                        <div className='organization-tabs-container'>
                            {organizations.map((item) => (
                                <button
                                    key={item.organizationsName}
                                    className={`organization-tab ${activeOrganizationTab === item.organizationsName ? 'active' : ''}`}
                                    onClick={() => {
                                        setActiveOrganizationTab(item.organizationsName);
                                        getOrganizationalEvaluation(item.organizationsName, activeObjectiveTab, startDate, endDate, frequency);
                                    }}
                                >
                                    {item.organizationsLabel}
                                </button>
                            ))}
                        </div>

                        {/* Objective Controls */}
                        <div className='objective-controls'>
                            <div className='objective-label'>Select Objective:</div>
                            {objectives.map((item) => (
                                <button
                                    key={`${item.id}`}
                                    className={`objective-tab ${activeObjectiveTab == item.id ? 'active' : ''}`}
                                    onClick={() => {
                                        if (controllerRef.current) {
                                            controllerRef.current.abort();
                                        }
                                        controllerRef.current = new AbortController();
                                        const [startDate, endDate] = dateRange;
                                        setActiveObjectiveTab(item.id);
                                        const obj = objectives.find(objective => objective.id == item.id);
                                        setActiveObjectiveName(obj ? obj.name : 'NA');
                                        getOrganizationalEvaluation(activeOrganizationTab, item.id, startDate, endDate, frequency);
                                    }}
                                >
                                    {item.name}
                                </button>
                            ))}
                        </div>

                        {/* Date Range Controls */}
                        <div className='date-range-controls'>
                            <div className='date-picker-container'>
                                <DatePicker views={['year', 'month']} openTo="month" datetitle={'text-12 fw-500 text-4E4E4E'} datepicker={"bg-black text-white"} icon={"calendar-dark"} startDate={startDate} endDate={endDate} handleDateRangeChange={handleDateRangeChange} />
                            </div>
                        </div>
                    </div>

                    {/* Metrics Cards */}
                    <div className='metrics-cards-container'>
                        <CardsOrganizational
                            isMetricsCard={true}
                            totalCount={metrics.length}
                            CardLabel="Metrics Considered"
                            onMetricsCardClick={handleMetricsCardClick}
                            isLoading={organizationalEvaluationLoading}
                        />
                        <CardsOrganizational
                            isMetricsCard={true}
                            metricsCardType="green"
                            totalCount={greenMeticsCount}
                            CardLabel="Green Level"
                            onDetailsClick={handleOrganizationalMetricsCardClick}
                            isLoading={organizationalEvaluationLoading}
                        />
                        <CardsOrganizational
                            isMetricsCard={true}
                            metricsCardType="amber"
                            totalCount={yellowMeticsCount}
                            CardLabel="Amber Level"
                            onDetailsClick={handleOrganizationalMetricsCardClick}
                            isLoading={organizationalEvaluationLoading}
                        />
                        <CardsOrganizational
                            isMetricsCard={true}
                            metricsCardType="red"
                            totalCount={redMeticsCount}
                            CardLabel="Red Level"
                            onDetailsClick={handleOrganizationalMetricsCardClick}
                            isLoading={organizationalEvaluationLoading}
                        />
                    </div>
                </div>

            </div>

            <div className='risk-analysis-group'>
                <Charts
                    objectiveName={activeObjectiveName}
                    metricsCount={metrics.length}
                    objectivesCount={objectives.length}
                    greenMeticsCount={greenMeticsCount}
                    yellowMeticsCount={yellowMeticsCount}
                    redMeticsCount={redMeticsCount}
                    dateRangeData={dateRangeData}
                    isDataLoading={organizationalEvaluationLoading}
                    allMetric={metrics}
                    activeMetric={activeMetric}
                    dateRange={dateRange}
                    onMetricChange={(metric) => setActiveMetric(metric)}
                    onDataChange={(data) => setActiveMetric(
                        (Array.isArray(data) ? data : []).map(item => ({
                            date: item.date,
                            target: item.target,
                            result: item.result,
                            riskLevel: item.risk
                        }))
                    )}
                    onFrequencyChange={(newFrequency) => {
                        setFrequency(newFrequency);
                        const [startDate, endDate] = dateRange;
                        getOrganizationalEvaluation(activeOrganizationTab, activeObjectiveTab, startDate, endDate, newFrequency);
                    }}
                />

                <RiskAnalysisTable
                    isDataLoading={organizationalEvaluationLoading}
                    dateRangeData={dateRangeData}
                    activeMetric={activeMetric}
                    metricBranchDataRangeData={getMetricDataByTab()}
                    dateRange={dateRange}
                    date={startDate && endDate ?
                        `${startDate.getMonth() + 1}/${startDate.getFullYear()} → ${endDate.getMonth() + 1}/${endDate.getFullYear()}` :
                        ''
                    }
                    columnName={getPopupTableColumnName(activeOrganizationTab)}
                />
            </div>

            {/* Metrics Considered Modal */}
            <MetricsConsideredModal
                show={showMetricsModal}
                onHide={() => setShowMetricsModal(false)}
                objective={activeObjectiveName}
                metricsDateRangeData={metricsDateRangeData}
                isDataLoading={organizationalEvaluationLoading}
                date={startDate && endDate ?
                    `${startDate.getMonth() + 1}/${startDate.getFullYear()} → ${endDate.getMonth() + 1}/${endDate.getFullYear()}` :
                    ''
                }
            />

            {/* Organizational Metrics Modal */}
            <OrganizationalMetricsModal
                show={orgMetricsModalState.show}
                onHide={closeOrgMetricsModal}
                data={metricsDateRangeData}
                title={orgMetricsModalState.title}
                cardType={orgMetricsModalState.cardType}
                date={startDate && endDate ?
                    `${startDate.getMonth() + 1}/${startDate.getFullYear()} → ${endDate.getMonth() + 1}/${endDate.getFullYear()}` :
                    ''
                }
            />
        </div>
    );
};

export default Dashboard;
